module.exports = __webpack_public_path__ + "img/icon-social-zhihu.1dc5a4ff.svg";